module.exports = __webpack_public_path__ + "img/tl.e1b4bdfd.svg";